import { __decorate } from "tslib";
import { Component } from '@angular/core';
import { SpinnerService } from './spinner.service';
let SpinnerComponent = class SpinnerComponent {
    constructor(spinner) {
        spinner.status.subscribe((status) => {
            this.active = status;
        });
    }
};
SpinnerComponent.ctorParameters = () => [
    { type: SpinnerService }
];
SpinnerComponent = __decorate([
    Component({
        selector: 'spinner-component',
        template: __importDefault(require("./spinner.component.html")).default
    })
], SpinnerComponent);
export { SpinnerComponent };
